import { Box, List, ListItem, Skeleton, styled } from "@mui/material";

import React from "react";
import { SpecialCoinWrapper } from "./SpecialCoins";

function SpecialCoinsSkeleton() {
  return (
    <SpecialCoinWrapper>
      <List>
        {[1, 2, 3, 4, 5, 6, 7]?.map(() => (
          <ListItemStyle>
            <CoinName>
              <Skeleton
                sx={{ display: "inline-block" }}
                width={40}
                variant="text"
              />{" "}
              /{" "}
              <Skeleton
                sx={{ display: "inline-block" }}
                variant="text"
                width={40}
              />
            </CoinName>

            <CoinStock>
              <Skeleton variant="text" width={40} />
            </CoinStock>

            <CoinPrice>
              <Skeleton
                sx={{ marginLeft: "auto", marginBottom: 1 }}
                variant="text"
              />
              <Skeleton sx={{ marginLeft: "auto" }} variant="text" />
            </CoinPrice>
          </ListItemStyle>
        ))}
      </List>
    </SpecialCoinWrapper>
  );
}

const ListItemStyle = styled(ListItem)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  borderBottom: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(1),
  "&:last-child": {
    borderBottom: `none`,
  },
}));

const CoinName = styled(Box)(() => ({
  flex: "0 0 35%",
  maxWidth: "0 0 30%",
}));

const CoinStock = styled(Box)(() => ({
  flex: "0 0 25%",
  maxWidth: "0 0 30%",
  display: "flex",
  alignItems: "center",
}));

const CoinPrice = styled(Box)(() => ({
  flex: "0 0 40%",
  maxWidth: "0 0 40%",
  textAlign: "right",
}));

export default SpecialCoinsSkeleton;
